// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_profiling_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { KubernetesResourceRequirements } from "./kubernetes_resource_spec_pb";
import { RPC } from "../../../../../runtime";

/**
 * The request message to get suggested resource for given composition.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ComputeSuggestedScoringResourceRequirementsRequest
 */
export type ComputeSuggestedScoringResourceRequirementsRequest = {
/**
 * experiment hosting the model to be deployed.
 *
 * @generated from field: string experiment = 1;
 */
experiment: string;
/**
 * runtime name for which requirements should be calculated
 *
 * @generated from field: string runtime = 2;
 */
runtime: string;
/**
 * Optional additional field
 * The number of runtime worker processes (degree of parallelization), only applicable to python based scorers.
 * If omit the value then it will fallback to 1.
 *
 * @generated from field: optional int32 workers = 3;
 */
workers?: number;
}
;
/**
 * The response message to represent suggested resource.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ComputeSuggestedScoringResourceRequirementsResponse
 */
export type ComputeSuggestedScoringResourceRequirementsResponse = {
/**
 * The k8s resource bounds.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesResourceRequirements kubernetes_resource_requirements = 1;
 */
kubernetesResourceRequirements?: KubernetesResourceRequirements;
}
;
/**
 * Get suggested resource bounds for given composition.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentProfilingService.ComputeSuggestedScoringResourceRequirements
 */
export const DeploymentProfilingService_ComputeSuggestedScoringResourceRequirements = new RPC<ComputeSuggestedScoringResourceRequirementsRequest,ComputeSuggestedScoringResourceRequirementsResponse>("POST", "/v2/{experiment=workspaces/*/experiments/*}:computeSuggestedScoringResourceRequirements");
